export const initialState = {
  questionnaire: {
    questionnaireName: '',
    questionnaireId: null,
    questionnaireScore: null,
    documentId: null,
    siteId: null,
    partnerId: null,
    loaded: false
  },
  answeredQuestions: [],
  currentQuestion: {
    orderId: 0,
    questionName: 'N/A',
    answer: '',
    questionScore: null,
    freeTxt: '',
    loaded: false,
    isFinalQuestion: false,
    isEmptyQuestion: false,
    mandatory: false
  },
  isFinished: false
};

export function reducer(state, action) {
  switch (action.type) {
    case 'OnInitState':
      return onInitState(state, action);
    case 'OnQuestionnaireUpdated':
      return onQuestionnaireUpdated(state, action);
    case 'OnCurrentQuestionPropertyChanged':
      return onCurrentQuestionPropertyChanged(state, action);
    case 'OnStart':
      return onStart(state, action);
    case 'OnNext':
      return onNext(state, action);
    case 'OnFinish':
      return onFinish(state);

    default:
      return state;
  }
}

function onInitState(state, action) {
  const { answeredQuestions, documentId, siteId, partnerId, totalScore } = action;
  return {
    ...state,
    questionnaire: {
      ...state.questionnaire,
      documentId: documentId,
      questionnaireScore: totalScore,
      siteId: siteId,
      partnerId: partnerId
    },
    answeredQuestions: answeredQuestions.map(item => {
      return { ...item };
    })
  };
}

function onQuestionnaireUpdated(state, action) {
  const { questionnaireId, questionnaireName } = action;
  return {
    ...state,
    questionnaire: {
      ...state.questionnaire,
      questionnaireId: questionnaireId,
      questionnaireName: questionnaireName,
      loaded: true
    }
  };
}

function onCurrentQuestionPropertyChanged(state, action) {
  const { propertyName, propertyValue } = action;
  return {
    ...state,
    currentQuestion: {
      ...state.currentQuestion,
      [propertyName]: propertyValue,
      loaded: true
    }
  };
}

function onStart(state, action) {
  const { nextQuestion, startQuestionNo } = action;

  let index = startQuestionNo || 0;
  if (index > 0) index--;
  const newAnsweredQuestions = Object.assign([...state.answeredQuestions]);
  newAnsweredQuestions.splice(index);
  return {
    ...state,
    answeredQuestions: newAnsweredQuestions,
    currentQuestion: { ...nextQuestion, loaded: true }
  };
}

function onNext(state, action) {
  const { currentQuestion, nextQuestion } = action;

  const newAnsweredQuestions = Object.assign([...state.answeredQuestions]);
  if (currentQuestion && currentQuestion.loaded) {
    const questionScore = currentQuestion.answers.find(x => x.questionValue === currentQuestion.answer)?.questionScore;
    newAnsweredQuestions.push({ ...currentQuestion, questionScore: questionScore ? questionScore : null });
  }
  return {
    ...state,
    answeredQuestions: newAnsweredQuestions,
    currentQuestion: { ...nextQuestion, freeTxt: '', loaded: true }
  };
}

function onFinish(state) {
  return {
    ...state,
    isFinished: true
  };
}
